import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.ends-with.js";
var ERROR_LIST = {
  unknown: 'ERROR_UNKNOWN',
  allInCart: 'ERROR_ALL_IN_CART'
};
export var shopifyAjaxErrorGet = function shopifyAjaxErrorGet(e) {
  var error = 'unknown';

  if (e && e.description) {
    if (e.description.startsWith('All') && e.description.endsWith('in your cart.')) {
      error = 'allInCart';
    }
  }

  return ERROR_LIST[error];
};